const BASE_URL = "https://api.4seasongarments.com.pk";
//const BASE_URL = "http://localhost:4003";

export default BASE_URL;